import { addShippingAddressArgsToParams } from 'data/api/transformers/arguments/add-shipping-address-args-to-params'
import { AddShippingAddressArgs } from 'types/api/arguments/add-shipping-address-args'
import { UserAddressResp } from 'types/api/response/user-address-resp'

import { api } from './api'

export const addShippingAddress = (args: AddShippingAddressArgs) =>
  api.post<UserAddressResp>(`/transactions/${args.transactionId}/shipping_destination`, {
    user_address: addShippingAddressArgsToParams(args),
  })
